import AcquireTokenCallback from './schema/AcquireTokenCallback';
import acquireTokenFromAuthContext from './utils/acquireTokenFromAuthContext';
import { lazyCreateAdalAuthenticationContext } from 'owa-adal-angular';
import getAuthenticationUrl from './utils/getAuthenticationUrl';
import loginUserAndAcquireToken from './utils/loginUserAndAcquireToken';

export async function getAccessTokenOnBehalfOfResource(
    clientId: string,
    redirectUri: string,
    resource: string,
    authChallenge: string,
    getAccessTokenCallback: AcquireTokenCallback
): Promise<void> {
    const authUrl = getAuthenticationUrl();
    const authContext = await lazyCreateAdalAuthenticationContext.importAndExecute(
        authUrl,
        clientId,
        redirectUri
    );
    const user = authContext.getCachedUser();
    if (user) {
        acquireTokenFromAuthContext(authContext, resource, authChallenge, getAccessTokenCallback);
    } else {
        loginUserAndAcquireToken(authContext, resource, authChallenge, getAccessTokenCallback);
    }
}
